import axios from "axios";
import { getOptions } from "../config";

class GitHubService {
    basePath: string;

    constructor() {
        this.basePath = "https://api.github.com";
    }

    getUserData(username: string): Promise<any> {
        return (axios as any)(getOptions(`${this.basePath}`, `/users/${username}`));
    }

    getUserRepositories(username: string): Promise<any> {
        return (axios as any)(getOptions(`${this.basePath}`, `/users/${username}/repos`));
    }

    getRepositoryTopics(username: string, repository: string): Promise<any> {
        return (axios as any)(
            getOptions(`${this.basePath}`, `/users/${username}/${repository}/topics`)
        );
    }
}

export default new GitHubService();
